// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_szW","cls2":"RelatedPapers-cls2_C7Q RelatedPapers-cls1_szW"};